export default __webpack_public_path__ + "static/media/119t.3703bdcd.jpg";